<template>
    <div>
        <!-- 顶部 Tab 栏：未入库 / 已入库 -->
        <div class="tabs">
            <div
                v-for="(item, index) in ['未入库', '已入库']"
                :key="index"
                :class="selectIndex === index ? 'action' : ''"
                @click="SelectChange(index)"
            >{{ item }}</div>
        </div>

        <Box title="入库信息" :SearchParams="IsSee" @SearchParams="IsSee = true" :AddButton="true" @Other="Other">
            <div class="contentBox">
                <!-- 未入库 Tab -->
                <div v-if="selectIndex === 0">
                    <keep-alive>
                        <WrkList ref="wrkListRef" :IsSee="IsSee" />
                    </keep-alive>
                </div>
                <!-- 已入库 Tab -->
                <div v-if="selectIndex === 1">
                    <keep-alive>
                        <YrkList ref="yrkListRef" :IsSee="IsSee" />
                    </keep-alive>
                </div>
            </div>
        </Box>
    </div>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    import WrkList from '../../components/PutInStorage/WrkList.vue'
    import YrkList from '../../components/PutInStorage/YrkList.vue'

    export default {
        name: 'PutInStorage',
        components: {
            Box,
            Field,
            LoadingFooter,
            WrkList,
            YrkList
        },
        data() {
            return {
                selectIndex: 0,
                IsSee: false,
            }
        },
        activated() {
            this.$Bus.$on('IsSee', (_IsSee) => {
                this.IsSee = _IsSee;
            });
        },
        methods: {
            SelectChange(index) {
                this.selectIndex = index;
                this.IsSee = false;
                // 切换到已入库 tab 时，主动刷新已入库列表
                if (index === 1 && this.$refs.yrkListRef) {
                    this.$refs.yrkListRef.refresh();
                }
            },
            // 新增设备 - 跳转验收详情页（新增模式）
            Other() {
                let NowDate = this.$format(new Date(), 'YYYY-MM-DD');
                this.$router.push({
                    name: 'EquipmentAcceptanceDetails',
                    params: {
                        AcceptanceInfoList: {
                            ISDomestic: '0',
                            ISDomesticMC: '国产',
                            JJSBBZ: '0',
                            TZSBBZ: '0',
                            SFQJ: 'N',
                            GYSB: '0',
                            KJKM: '',
                            KJKMMC: '',
                            SFCYXYFX: 'N',
                            QDRQ: NowDate,
                            GRRQ: NowDate,
                            BXRQ: NowDate,
                            SSRQ: NowDate,
                            PJBZ: 'N',
                            zczj: 0,
                            kyjf: 0,
                            jxjf: 0,
                            jsjz: 0,
                            zfbk: 0,
                            rzzl: 0,
                            qt: 0,
                            SL: '',
                            CGDJ: '',
                            ZJE: 0,
                            HH: 0,
                            GLLB: '',
                            YSBZ: '1',  // 直接入库模式
                        },
                        AZYS: [],
                        IsAddOrUpdata: false
                    }
                });
            }
        },
        watch: {}
    }
</script>

<style scoped lang="scss">
    .tabs {
        display: flex;
        align-items: center;
        background: #4FA69E;
        position: fixed;
        z-index: 10;
        top: 105px;
        width: 100%;

        div {
            flex: 1;
            height: 96px;
            text-align: center;
            line-height: 96px;
            font-size: 28px;
            color: #FFFFFF;
            border-radius: 14px 14px 0 0;
        }

        .action {
            font-size: 5vw;
            font-weight: bold;
            background: rgba(255, 255, 255, 0.15);
        }
    }

    .contentBox {
        margin-top: 105px;

        &>div {
            border-radius: 14px;
            background: #fff;
            margin-bottom: 30px;
        }
    }

    .commonBox {
        padding-bottom: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/page/putInStorage/putInStorage.vue